'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mutation;
/* eslint-disable no-param-reassign, no-use-before-define, prefer-template */

function mutation(relayRequest, fetchWithMiddleware) {
  var req = {
    method: 'POST',
    relayReqId: relayRequest.getID ? relayRequest.getID() : 'mutation' + Math.random(),
    relayReqObj: relayRequest,
    relayReqType: 'mutation'
  };

  if (hasFiles(relayRequest)) {
    mutationWithFiles(req, relayRequest);
  } else {
    mutationWithoutFiles(req, relayRequest);
  }

  return fetchWithMiddleware(req).then(function (data) {
    return relayRequest.resolve({ response: data });
  }).catch(function (err) {
    return relayRequest.reject(err);
  });
}

function hasFiles(relayRequest) {
  return !!(relayRequest.getFiles && relayRequest.getFiles());
}

function mutationWithFiles(req, relayRequest) {
  req.headers = {};

  if (hasFiles(relayRequest)) {
    var files = relayRequest.getFiles();

    if (!global.FormData) {
      throw new Error('Uploading files without `FormData` not supported.');
    }
    var formData = new FormData();
    formData.append('id', req.relayReqId);
    formData.append('query', relayRequest.getQueryString());
    formData.append('variables', JSON.stringify(relayRequest.getVariables()));
    Object.keys(files).forEach(function (filename) {
      if (Array.isArray(files[filename])) {
        files[filename].forEach(function (file) {
          formData.append(filename, file);
        });
      } else {
        formData.append(filename, files[filename]);
      }
    });
    req.body = formData;
  }
}

function mutationWithoutFiles(req, relayRequest) {
  req.headers = {
    Accept: '*/*',
    'Content-Type': 'application/json'
  };

  req.body = JSON.stringify({
    id: req.relayReqId,
    query: relayRequest.getQueryString(),
    variables: relayRequest.getVariables()
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/react-relay-network-layer/lib/relayMutation.js
// module id = 1517
// module chunks = 0